"use client";

import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-thin-svg-icons";
import { useForm } from "react-hook-form";
import { Button } from "@/components/button";
import { cn } from "@/lib/utils";

const searchTypes = [
  { value: "0", label: "Public Binders" },
  { value: "1", label: "Author" },
  //   { value: '2', label: 'My Binders' },
  //   { value: '3', label: 'Educational Category' },
  //   { value: '4', label: 'Shelves' },
  { value: "5", label: "Binder ID" },
  { value: "6", label: "Name" },
  { value: "7", label: "Description" },
  { value: "8", label: "Tags" },
];

export const SearchBox = ({ className, defaultValue, onSubmit }) => {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    reset(defaultValue);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={cn("my-5 p-1 overflow-hidden", className)}>
        <div className="md:flex items-center space-y-2 md:space-x-2 md:space-y-0">
          <div className="relative rounded-md basis-1/2">
            <input
              className="block w-full rounded-md border-0 py-2.5 pr-10 text-gray-950 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600"
              type="text"
              placeholder="Enter keywords..."
              {...register("terms", { required: true })}
            />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <FontAwesomeIcon icon={faSearch} aria-hidden="true" />
            </div>
          </div>

          <div className="flex items-center basis-1/2 space-x-3">
            <select
              className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
              defaultValue={searchTypes[0].value}
              {...register("type")}
            >
              {searchTypes.map(({ value, label }, index) => (
                <option key={index} value={value}>
                  {label}
                </option>
              ))}
            </select>
            <Button className="w-full ml-auto" type="submit" variant="ghost">
              Search
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};
